import { useEffect, useRef } from "react";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const usePrev = (value) => {
  // -------------------------- VAR -----------------------------
  const ref = useRef(null);
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    ref.current = value; // Cập nhật ref sau khi render
  }, [value]);
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return ref.current;
};
